// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___DmTc","links":"Footer_links__ssFz6","groups":"Footer_groups__jQws5","group":"Footer_group__aN9YU"};